module.exports = __webpack_public_path__ + "img/folder-icon.8b24b5fb.svg";